var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExecutiveTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D1F27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6471 22.576C22.6471 23.2077 22.3235 23.7219 21.9235 23.7219H5.72353C5.32353 23.7219 5 23.2077 5 22.576C5 21.9419 5.32353 21.4277 5.72353 21.4277H21.9235C22.3235 21.4277 22.6471 21.9419 22.6471 22.576Z",
    fill: "#06362B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6428 19.3776C9.6428 19.8211 9.21221 20.1846 8.6828 20.1846H7.24398C6.71339 20.1846 6.28516 19.8211 6.28516 19.3776V15.3305C6.28516 14.8858 6.71339 14.5234 7.24398 14.5234H8.6828C9.21221 14.5234 9.6428 14.8858 9.6428 15.3305V19.3776Z",
    fill: "#06362B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4826 19.3773C15.4826 19.822 15.0532 20.1831 14.5238 20.1831H13.0838C12.5544 20.1831 12.125 19.822 12.125 19.3773V14.1067C12.125 13.662 12.5544 13.3008 13.0838 13.3008H14.5238C15.0532 13.3008 15.4826 13.662 15.4826 14.1067V19.3773Z",
    fill: "#06362B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3968 19.3455C21.3968 19.7867 20.9651 20.1455 20.4274 20.1455H18.9733C18.4368 20.1455 18.0039 19.7867 18.0039 19.3455V11.6926C18.0039 11.2514 18.4368 10.8926 18.9733 10.8926H20.4274C20.9651 10.8926 21.3968 11.2514 21.3968 11.6926V19.3455Z",
    fill: "#06362B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86316 13.0981C5.41728 13.097 5.05022 12.7487 5.03375 12.3064C5.01728 11.8534 5.3761 11.4758 5.8361 11.4605C11.7232 11.2523 17.3279 8.98402 21.2173 5.23343C21.5455 4.91813 22.0702 4.92166 22.3937 5.24755C22.7149 5.5699 22.709 6.09107 22.3808 6.40637C18.1385 10.497 12.2832 12.8734 5.89375 13.097C5.88434 13.0981 5.87257 13.0981 5.86316 13.0981Z",
    fill: "#06362B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExecutiveTraining);
export default __webpack_public_path__ + "static/media/ic_executive_training.605a2cfe5e02623227c747441da40879.svg";
export { ForwardRef as ReactComponent };